import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@4.3.0@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dAdd",
  "use": "icon-dAdd-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-dAdd\">\r\n      <path d=\"M128 128v768h768V128H128zM96 64h832a32 32 0 0 1 32 32v832a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32z\" p-id=\"1758\" />\r\n      <path d=\"M554.144 554.56v228.608h-85.568V554.56H239.936v-85.6h228.64V237.76h85.568v231.168h231.2v85.6h-231.2z\" p-id=\"1759\" />\r\n    </symbol>"
});
var result = sprite.add(symbol);
export default symbol